var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProviderRequestContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a0df;}.cls-2{fill:#0072b2;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "provider_request_contact"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 299.12,
    cy: 300,
    r: 300
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.56,
    y: 105.25,
    width: 199.74,
    height: 249.85,
    rx: 30.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 105.68,
    y: 139.91,
    width: 51.48,
    height: 26.08,
    rx: 13.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 105.68,
    y: 287.66,
    width: 51.48,
    height: 26.08,
    rx: 13.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 105.68,
    y: 189.16,
    width: 51.48,
    height: 26.08,
    rx: 13.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 105.68,
    y: 238.41,
    width: 51.48,
    height: 26.08,
    rx: 13.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.94,227a25.54,25.54,0,0,1,13,3.5,25.91,25.91,0,0,1,9.54,9.54,25.55,25.55,0,0,1,3.5,13v8.17a9.3,9.3,0,0,1-9.34,9.34H202.18a9.3,9.3,0,0,1-9.34-9.34v-8.17a25.45,25.45,0,0,1,3.5-13,25.88,25.88,0,0,1,9.53-9.54,25.57,25.57,0,0,1,13-3.5h3.31a34,34,0,0,0,28.41,0Zm-17.52-6.23a24.75,24.75,0,0,1-12.55-3.3,24.41,24.41,0,0,1-9.05-9.05,25.53,25.53,0,0,1,0-25.11,24.31,24.31,0,0,1,9.05-9,25.45,25.45,0,0,1,25.1,0,24.16,24.16,0,0,1,9,9,25.47,25.47,0,0,1,0,25.11,24.26,24.26,0,0,1-9,9.05A24.72,24.72,0,0,1,236.42,220.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M369.08,523.52a58.33,58.33,0,0,1-58.26-58.26V418.1H262.46a56.8,56.8,0,0,1,0-113.59h48.36V257.42a58.26,58.26,0,1,1,116.52,0v47.09H483.5a56.8,56.8,0,1,1,0,113.59H427.34v47.16A58.33,58.33,0,0,1,369.08,523.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.08,214.16a43.38,43.38,0,0,1,43.26,43.26v62.09h71.17a41.8,41.8,0,0,1,0,83.59H412.34v62.16a43.26,43.26,0,0,1-86.52,0V403.1H262.46a41.8,41.8,0,0,1,0-83.59h63.36V257.42a43.39,43.39,0,0,1,43.26-43.26m0-30a73.35,73.35,0,0,0-73.26,73.26v32.09H262.46a71.8,71.8,0,0,0,0,143.59h33.36v32.16a73.26,73.26,0,0,0,146.52,0V433.1h41.17a71.8,71.8,0,0,0,0-143.59H442.34V257.42a73.34,73.34,0,0,0-73.26-73.26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderRequestContact);
export default __webpack_public_path__ + "static/media/provider_request_contact.6eff589008e5730ef6f442f82adfe2c2.svg";
export { ForwardRef as ReactComponent };